import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    rules: _ctx.rules,
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.log")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_el_table, {
            data: _ctx.itemTable,
            style: {"width":"100%"},
            size: "small",
            "min-width": "220"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: _ctx.t('shipments.dateTime')
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.created_at)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.t('shipments.systemUser')
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.__show.created_uid), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.t('shipments.logType')
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.__show.status), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.t('shipments.logDescription'),
                prop: "description"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data"])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}